export default __webpack_public_path__ + "static/media/Literatus Hood.f45b6676.jpg";